<template>
</template>

<script>
export default {
    props: ['module'],
    created() {
        this.$root.$on('open-modal-destroy-module-' + this.module.id, () => {
            this.openModalDestroy();
        });
    },
    methods: {
        openModalDestroy(course) {
            this.$bvModal.msgBoxConfirm('Você tem certeza que deseja excluir este módulo?', {
                cancelTitle: 'Cancelar',
                okTitle: 'Excluir',
                cancelVariant: 'default',
                okVariant: 'danger'
            }).then(answer => {
                if (answer) {
                    this.loading = true;
                    axios.delete('/teacher/courses/' + this.module.course_id + '/modules/' + this.module.id)
                        .then((result) => {

                            // Message
                            this.$toast.success('Módulo excluido com sucesso!');

                            // Load
                            this.$emit('destroyed');
                        })
                        .finally(() => this.loading = false)
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
